export const DRAFT_FIELDS = [
  "issue", "description", "equipments", "assignTo", "priority", "workorder_type",
  "recommended_action", "reportBy", "due_date", "status",
];

export const sameDraftScope = (scope, companyId, facilityId) => Boolean(
  scope && companyId && facilityId &&
  String(scope.company_id) === String(companyId) &&
  String(scope.facility_id) === String(facilityId)
);

export const fieldValue = (value) => (
  value && typeof value.format === "function" ? value.format("YYYY-MM-DD") : value
);

const comparable = (value) => (Array.isArray(value) ? JSON.stringify(value) : fieldValue(value));

// Only fill empty fields or replace an unchanged value from the previous draft.
// A field edited while the request was running must also be preserved.
// 注：后端草稿的 values.equipment 仍是单值 id（第一台代表），落入表单 equipments 数组。
export const draftValuesToApply = ({ draft, companyId, facilityId, current, snapshot, previous = {} }) => {
  if (draft?.saved !== false || !sameDraftScope(draft?.scope, companyId, facilityId)) {
    throw new Error("This draft belongs to a different facility. Please generate it again.");
  }
  const values = {};
  for (const key of DRAFT_FIELDS) {
    const rawCandidate = key === "equipments" ? draft.values?.equipment : draft.values?.[key];
    if (rawCandidate === undefined || rawCandidate === null || rawCandidate === "") continue;
    if (["equipments", "assignTo"].includes(key) && (!Number.isInteger(rawCandidate) || rawCandidate <= 0)) continue;
    if (!["equipments", "assignTo"].includes(key) && typeof rawCandidate !== "string") continue;
    const candidate = key === "equipments" ? [rawCandidate] : rawCandidate;
    const existing = comparable(current[key]);
    if (existing !== comparable(snapshot[key])) continue;
    const empty = existing === undefined || existing === null || existing === "" || existing === "[]";
    if (empty || (key in previous && existing === comparable(previous[key]))) values[key] = candidate;
  }
  return values;
};
